import React from 'react';
import { numberMask } from 'components/Input/Masks';
import BuscaAvancada, { BuscaAvancadaContext } from '../../components/BuscaAvancada/buscaAvancada.component';
import Input from '../../components/Input/input.component';
import SelectMulti from '../../components/SelectMulti/selectmulti.component';

const PesquisaAvancadaDaca = (props) => {
	const filtro = {
		codigo: '',
		nome: '',
		tipoItem: [],
		localExibicao: [],
	};

	const { handlePesquisaSimplificada, handleSearch, handleClear } = props;

	return (
		<BuscaAvancada
			initialValues={filtro}
			handleSearch={handleSearch}
			handleClear={handleClear}
			handlePesquisaSimplificada={handlePesquisaSimplificada}
		>
			<BuscaAvancadaContext.Consumer>
				{({
					values,
					handleChange,
					setFieldValue,
				}) => (
					<React.Fragment>
						<div className='row'>
							<div className='col-6'>
								<label>Item</label>
								<Input onChange={handleChange} value={values.nome || ''} name='nome' />
							</div>

							<div className='col-6 mb-1'>
								<label>Código</label>
								<Input
									maxLength={18}
									onChange={handleChange}
									value={values.codigo || ''}
									name='codigo'
									mask={numberMask}
								/>
							</div>

							<div className='col-6'>
								<label>Tipo de item</label>
								<SelectMulti
									isMulti
									isClearable
									name='tipoItem'
									uniqueKey='value'
									label='label'
									onChange={(value) => {
										setFieldValue('tipoItem', value);
									}}
									value={values.tipoItem || []}
									options={[
										{
											value: true,
											label: 'Material permanente',
										},
										{
											value: false,
											label: 'Bens de consumo',
										},
									]}
								/>
							</div>

							<div className='col-6'>
								<label>Local de exibição</label>
								<SelectMulti
									isMulti
									isClearable
									name='localExibicao'
									uniqueKey='value'
									label='label'
									value={values.localExibicao || []}
									onChange={(value) => {
										setFieldValue('localExibicao', value);
									}}
									options={[
										{
											value: 1,
											label: 'PDR',
										},
										{
											value: 2,
											label: 'PDP',
										},
										{
											value: 3,
											label: 'Não exibir',
										},
									]}
								/>
							</div>
						</div>
					</React.Fragment>
				)}
			</BuscaAvancadaContext.Consumer>
		</BuscaAvancada>
	);
};

export default PesquisaAvancadaDaca;
